import React from "react";
import tbmStar from "../../assets/rebrand/tbm-star.png";

const PanelGreeting = ({ handleWorkoutPlanner, handleQuote }) => {
  return (
    <div>
      <h1 className="display-5">Bienvenida tu espacio TBM</h1>
      <p>¿Lista para seguir construyendo tu máximo potencial?</p>
      <p>
        Haz que cada sesión cuente con rutinas diseñadas para acercarte a tus
        objetivos con constancia y resultados reales.
      </p>
      <p>
        Conecta contigo a través del movimiento y descubre una versión más
        fuerte de ti, por dentro y por fuera.
      </p>
      <div className="row">
        <div className="col-12 col-md-12 col-lg-12 col-xl-6 mb-2">
          <button
            onClick={handleWorkoutPlanner}
            className="btn d-block m-auto btn-primary"
          >
            Mi Workout Planner
          </button>
        </div>
        <div className="col-12 col-md-12 col-lg-12 col-xl-6 mb-2">
          <button
            onClick={handleQuote}
            className="btn d-block m-auto btn-secondary"
          >
            Frase del Día
          </button>
          <label className="small mt-2 w-100 d-block text-center">
            El mensaje que el universo tiene para ti{" "}
            <img
              src={tbmStar}
              alt=""
              aria-hidden
              className="d-inline-block align-text-bottom"
              style={{ height: "1em", width: "auto", objectFit: "contain" }}
            />
          </label>
        </div>
      </div>
    </div>
  );
};

export default PanelGreeting;
